import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { createHookContext } from '@clover-util/react-context';
import { usePureState } from '@clover-util/use-pure-state';
const { useScriptRegistry, ScriptRegistryProvider, ScriptRegistryContext } = createHookContext('ScriptRegistry', () => {
    const [registry, update] = usePureState({});
    const register = useCallback((src) => update({ [src]: true }), [update]);
    const find = useCallback((src) => { var _a; return (_a = registry[src]) !== null && _a !== void 0 ? _a : false; }, [registry]);
    return useMemo(() => ({ register, find }), [register, find]);
});
const ScriptRegistryProviderWrapper = memo(props => {
    const existing = useContext(ScriptRegistryContext);
    if (existing)
        return _jsx(_Fragment, { children: props.children });
    return _jsx(ScriptRegistryProvider, { children: props.children });
});
ScriptRegistryProviderWrapper.displayName = 'ScriptRegistryProvider (Wrapper)';
export { ScriptRegistryProviderWrapper as ScriptRegistryProvider };
export function useScript(srcFactoryOrConfig) {
    const { register, find } = useScriptRegistry();
    const { src, async, text, type, defer } = (() => {
        if (typeof srcFactoryOrConfig === 'string')
            return { src: srcFactoryOrConfig };
        return srcFactoryOrConfig !== null && srcFactoryOrConfig !== void 0 ? srcFactoryOrConfig : { src: '' };
    })();
    const [error, onerror] = useState();
    const config = useMemo(() => ({
        src,
        async: async !== null && async !== void 0 ? async : true,
        text,
        type,
        defer,
        onload() { register(src); },
        onerror,
    }), [src, async, text, type, defer, register]);
    const isLoaded = useMemo(() => find(src), [find, src]);
    useEffect(() => {
        // has the script already been added into the document?
        if (!src || Array.from(document.scripts).find(script => script.src === src))
            return;
        const el = document.createElement('script');
        Object.entries(config).forEach(([key, value]) => {
            if (value === undefined || value === null)
                return;
            el[key] = value;
        });
        document.body.appendChild(el);
    }, [config, src]);
    return Object.assign([isLoaded, error], { isLoaded, error });
}
//# sourceMappingURL=ScriptRegistry.js.map